<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false" top="17vh" width="500px">
    <el-alert title="可以根据项目编号来搜索" type="warning"> </el-alert>
    <el-select v-model="copiedProId" placeholder="请选择项目" size="mini" filterable style="width:100%">
      <el-option v-for="item in proOptions" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
    <span slot="footer" class="dialog-footer">
      <span class="mr10"> <el-button size="mini" type="danger" @click="onCancel">取 消</el-button> </span>
      <el-button size="mini" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      copiedProId: '',
      proOptions: [],
    }
  },
  methods: {
    async open(type, project) {
      this.dialogVisible = true
      this.dialogType = type
      this.initProject = project
      let arr
      if (type === '同公司') {
        arr = app.projects.filter(val => val.客户公司 === project.客户公司 && val._id !== project._id)
      } else {
        arr = app.projects.filter(val => val.职能模块 === project.职能模块 && val._id !== project._id)
      }
      this.proOptions = arr.map(item => {
        const label = `${item['项目名称']}(${item['客户公司']})(${item.编号})`
        return { label: label, value: item._id }
      })
    },
    onCancel() {
      this.dialogVisible = false
    },
    async onConfirm() {
      if (this.copiedProId) {
        const project = await app.service('project').fetch(this.copiedProId)
        this.$emit('copyProject', project)
        this.dialogVisible = false
      } else {
        return this.$message.info('请选择项目')
      }
    },
    async confirm(type) {
      this.$emit('confirm', { type: type, data: null })
    },
  },
}
</script>
<style scoped>
.display-flex {
  display: flex;
}
.cutoff-line {
  flex: 1;
  height: 1px;
  background-color: #c9c7c7;
  align-self: center;
}
.confirm-btn-box {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.confirm-btn-box span {
  font-size: 12px;
}
</style>
